module.exports = __webpack_public_path__ + "static/media/location.abc30517.svg";